import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The Analytics Object`}</h2>
    <p>{`Most of our endpoints return an Analytics Object. The Analytics Object provides URLs so you can register actions, such as when a user views, clicks, or sends a GIF. For detailed instructions, refer to the `}<a href="/docs/api/endpoint#action-register">{`Action Register Endpoint`}</a>{`.`}</p>
    <div className="props-table-three">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Property`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}></th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Example`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`onload:`}</strong>{` `}<em parentName="td">{`object`}</em></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{` The URL to register a 'view' action by a user.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`"URL"`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`onclick:`}</strong>{` `}<em parentName="td">{`object`}</em></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{` The URL to register a 'click' action by a user.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`"URL"`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`onsent:`}</strong>{` `}<em parentName="td">{`object`}</em></td>
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{` The URL to register a 'send' action by a user.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`"URL"`}</td>
          </tr>
        </tbody>
      </table>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      